import { render, staticRenderFns } from "./PageHeaderTabs.vue?vue&type=template&id=4e84c951&"
import script from "./PageHeaderTabs.vue?vue&type=script&lang=ts&"
export * from "./PageHeaderTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports